/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  HomePageToolkit,
  HomePageStarredEntities,
  TemplateBackstageLogoIcon,
} from '@backstage/plugin-home';
import { Content, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { LeoVegasBanner} from "./LeoVegasBanner";
import Grid from '@material-ui/core/Grid';
import React from 'react';
import ImageRender from './ImageRender';
import graflogo from './images/Grafana_logo.svg.png'
import garlogo from './images/gar_logo.svg'
import nexlogo from './images/nexus-white.png'
import jenklogo from './images/jenkins.svg'
import ddlogo from './images/dd_logo.png'

const toolsArray = [{
  url: 'https://tero-dot-leo-platform-infra.appspot.com/',
  label: 'Tero (Environment overview)',
  icon: <TemplateBackstageLogoIcon />
},
{
  url: 'https://grafana.leo-dev-common.lvg-tech.net/login',
  label: 'Grafana (For service deploys)',
  icon: <ImageRender image={graflogo} alt="Grafana" width="50" height="50" />
},
{
  url: 'https://console.cloud.google.com/artifacts?authuser=1&project=leo-platform-infra',
  label: 'Google Artifact Registry',
  icon: <ImageRender image={garlogo} alt="Google Artifact Registry" width="50" height="50" />
},
{
  url: 'https://delivery-nexus.leo-platform-infra.lvg-tech.net/',
  label: 'Nexus (Artifact repository)',
  icon: <ImageRender image={nexlogo} alt="Grafana" width="50" height="50" />
},
{
  url: 'https://delivery-builds.leo-platform-infra.lvg-tech.net/blue/pipelines/',
  label: 'Jenkins (CI/CD system)',
  icon: <ImageRender image={jenklogo} alt="Grafana" width="50" height="50" />
},
{
  url: 'https://app.datadoghq.eu/account/login/id/ro95lynavehwtsby',
  label: 'DataDog (Monitoring and APM)',
  icon: <ImageRender image={ddlogo} alt="Grafana" width="50" height="50" />
}
]

export const homePage = (
  <Page themeId="home">
    <Content noPadding>
      <LeoVegasBanner />
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={10}>
          <HomePageSearchBar style={{padding: '0.5rem'}} color="secondary" />
        </Grid>
      </Grid>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={5}>
          <HomePageStarredEntities />
        </Grid>
        <Grid item xs={12} md={5}>
          <HomePageToolkit
            tools={toolsArray.map(val => val)}
          />
        </Grid>
      </Grid>
    </Content>
  </Page>
)
